<template>
  <div class="_modals">
    <b-modal
      id="_rate_us_modal"
      ref="modalRateUs"
      centered
      hide-footer
      no-close-on-backdrop
      @show="closeModal"
      @hidden="closeModal"
    >
      <div class="row align-items-center" v-if="isLoadingRate">
        <half-circle-spinner
          :animation-duration="1500"
          :size="100"
          color="#1D3354"
          class="mx-auto"
        />
      </div>
      <div v-else-if="rate">
        <div class="top__block">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
              <p class="feedback">Feedback</p>
              <p class="feedback-p">Tell us how was our service!</p>
            </div>
            <div>
              <p class="top__block--details mb-2">
                {{ rate.reference_number }}
              </p>
              <p class="top__block--details">
                {{ rate.origin_city }} [{{ rate.origin_country_code }}] to
                {{ rate.destination_city }} [{{
                  rate.destination_country_code
                }}]
              </p>
            </div>
          </div>
          <div class="mb-2">
            <p
              style="font-weight: 600;font-size: 14px;color: #1D3354;"
              class="input-label"
            >
              Choose your stage of shipment<span class="fontstyle__errormsg">*</span>
            </p>
            <div class="options__multipleselect">
              <multiselect
                v-model="form.shipment"
                :options="optionShipment || []"
                label="name"
                :placeholder="'Select shipment stage'"
                name="shipment stage"
                v-validate="'required'"
                :allow-empty="false"
                :show-labels="false"
              >
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/icon-arrow-blue.png"
              />
            </div>
            <div class="fontstyle__errormsg">
              {{ errors.first("shipment stage") }}
            </div>
          </div>
          <div class="mb-4">
            <p
              style="font-weight: 600;font-size: 14px;color: #1D3354;"
              class="input-label"
            >
              Team<span class="fontstyle__errormsg">*</span>
            </p>
            <div class="options__multipleselect">
              <multiselect
                v-model="form.team"
                :options="optionTeam || []"
                label="name"
                :placeholder="'Select team'"
                name="team"
                v-validate="'required'"
                :allow-empty="false"
                :show-labels="false"
              >
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/icon-arrow-blue.png"
              />
            </div>
            <div class="fontstyle__errormsg">
              {{ errors.first("team") }}
            </div>
          </div>
          <div class="mb-4">
            <ul class="d-flex">
              <li
                v-for="tab in listTabs"
                :key="tab.id"
                class="p-2 mr-5 text-center"
                style="cursor: pointer;margin-left: -40px;"
                :style="selectedTab === tab.name ? 'background: #E5EAED;border-radius: 4px;' : ''"
                @click="onSelectedTab(tab.name)"
              >
                <img class="mb-2" style="width: 72px;" :src="tab.url" alt="" />
                <p style="font-size: 16px;font-weight: 600;color: #4A4B4C;">
                  {{ tab.name }}
                </p>
              </li>
            </ul>
          </div>
          <div class="mb-2">
            <p
              style="font-weight: 600;font-size: 14px;color: #1D3354;"
              class="input-label"
            >
              Please write your experience here!<span class="fontstyle__errormsg">*</span>
            </p>
            <textarea
              rows="5"
              class="bottom__block--textarea"
              v-validate="'required'"
              name="experience"
              v-model="form.feedback"
            ></textarea>
            <div class="fontstyle__errormsg">
              {{ errors.first("experience") }}
            </div>
          </div>
          <div
            class="d-flex justify-content-start align-items-center w-100 mb-4"
          >
            <button class="button__bluecorporite" @click="submit">
              <span v-if="isLoadingPostRate">
                <b-spinner small variant="light" label="Spinning" />
              </span>
              <span v-else>
                Submit
              </span>
            </button>
            <p class="fontstyle__errormsg ml-2">{{ messageValidation }}</p>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="_rate_us_modal"
      ref="modalViewFeedback"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <div class="row align-items-center" v-if="isLoadingRate">
        <half-circle-spinner
          :animation-duration="1500"
          :size="100"
          color="#1D3354"
          class="mx-auto"
        />
      </div>
      <div v-else-if="rateDetail">
        <div class="top__block mb-5">
          <div class="d-flex justify-content-start mb-3">
            <p class="feedback">Feedback</p>
          </div>
          <div class="mb-2" style="width: 100%;border: 1px solid #DADEE2"></div>
          <div class="mb-2">
            <p
              style="font-weight: 600;font-size: 16px;color: #1D3354;"
              class="input-label mb-2"
            >
              Choose your stage of shipment
            </p>
            <p style="color: #686A6B;">{{ rateDetail.shipment_stage }}</p>
          </div>
          <div class="mb-4">
            <p
              style="font-weight: 600;font-size: 16px;color: #1D3354;"
              class="input-label mb-2"
            >
              Team
            </p>
            <p style="color: #686A6B;">{{ rateDetail.team }}</p>
          </div>
          <div class="mb-4 d-flex justify-content-start">
            <div class="p-2 mr-5 text-center">
              <img
                class="mb-2"
                style="width: 72px;"
                :src="
                  require(`@/assets/image/icon/${
                    rateDetail.rate >= 4
                      ? 'happy'
                      : rateDetail.rate === 3
                      ? 'netral'
                      : 'unhappy'
                  }.svg`)
                "
                alt=""
              />
              <p style="font-size: 16px;font-weight: 600;color: #4A4B4C;">
                {{
                  rateDetail.rate >= 4
                    ? "Happy"
                    : rateDetail.rate === 3
                    ? "Netral"
                    : "Unhappy"
                }}
              </p>
            </div>
          </div>
          <div class="mb-2">
            <p
              style="font-weight: 600;font-size: 16px;color: #1D3354;"
              class="input-label mb-2"
            >
              Please write your experience here!
            </p>
            <p style="color: #686A6B;">{{ rateDetail.feedback }}</p>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalSuccessUpload"
      ref="modalSuccessFeedback"
      hide-footer
      hide-header-close
      centered
    >
      <div class="text-center">
        <img class="mb-2" src="@/assets/image/icon/success-green.svg" alt="" />
        <p class="mb-2" style="color: #4FA462;">
          Thank you for your feedback. Your voice is important for us.
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
import { mapGetters } from 'vuex'

export default {
  name: 'RateUs',
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      shipmentId: '',
      selectedTab: '',
      messageValidation: '',
      form: {
        shipment: '',
        team: '',
        feedback: ''
      },
      optionShipment: [
        { name: 'Pre shipment', id: 1 },
        { name: 'During shipment', id: 2 },
        { name: 'Post shipment', id: 3 }
      ],
      optionTeam: [
        { name: 'Operation', id: 1 },
        { name: 'Sales', id: 2 },
        { name: 'Finance', id: 3 }
      ],
      listTabs: [
        {
          name: 'Happy',
          url: require('@/assets/image/icon/happy.svg')
        },
        {
          name: 'Netral',
          url: require('@/assets/image/icon/netral.svg')
        },
        {
          name: 'Unhappy',
          url: require('@/assets/image/icon/unhappy.svg')
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      // get data rate
      rate: 'rate/rate',
      errorRate: 'rate/errorRate',
      isLoadingRate: 'rate/isLoadingRate',

      rateDetail: 'rate/rateDetail',
      errorRateDetail: 'rate/errorRateDetail',
      isLoadingRateDetail: 'rate/isLoadingRateDetail',

      // post data rate
      postRate: 'rate/postRate',
      errorPostRate: 'rate/errorPostRate',
      isLoadingPostRate: 'rate/isLoadingPostRate'
    })
  },
  created () {
    this.$eventHub.$on('dialog-rate-us', this.dialogRateUs)
    this.$eventHub.$on('dialog-rate-us-second', this.dialogRateUsSecond)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-rate-us')
    this.$eventHub.$off('dialog-rate-us-second')
  },
  methods: {
    async dialogRateUs (id) {
      this.shipmentId = id
      await this.fetchRate(id)
      this.$refs.modalRateUs.show()
    },
    async dialogRateUsSecond (id) {
      await this.fetchRateDetail(id)
      this.$refs.modalViewFeedback.show()
    },
    fetchRate (id) {
      this.$store.dispatch('rate/FETCH_RATE', id)
    },
    fetchRateDetail (id) {
      this.$store.dispatch('rate/FETCH_RATE_DETAIL', id)
    },
    closeModal () {
      this.$refs.modalRateUs.hide()
      this.$refs.modalViewFeedback.hide()
      this.selectedTab = ''
      this.form.feedback = ''
      this.form.shipment = ''
      this.form.team = ''
    },
    onSelectedTab (name) {
      this.selectedTab = name
    },
    submit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.selectedTab) {
            let payload = {
              id_shipment: this.shipmentId,
              rate:
                this.selectedTab === 'Happy'
                  ? 5
                  : this.selectedTab === 'Netral'
                    ? 3
                    : 1,
              feedback: this.form.feedback,
              stage: this.form.shipment.name,
              team: this.form.team.name
            }
            this.$store.dispatch('rate/POST_RATE', payload)
            setTimeout(() => {
              this.$store.dispatch('shipment/FETCH_SHIPMENT_LIST', {
                type: 'completed',
                currentPage: 1,
                perPage: 10
              })
              this.closeModal()
              this.$refs.modalSuccessFeedback.show()
            }, 2000)
          } else {
            this.messageValidation = 'Oops! Please make a selection'
            setTimeout(() => {
              this.messageValidation = ''
            }, 2000)
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/RateUs.vue